import { useSnapshot } from 'valtio';
import { useDispatch } from 'react-redux';
import type { RootDispatch } from '@/components/WellLoggingOperations/types';

import { isTemplateDeleting } from '../stores/isTemplateDeleting';

type Options = {
    onSuccess?: () => void;
    onError?: () => void;
};

export const useDeleteTemplate = () => {
    const { isDeleting } = useSnapshot(isTemplateDeleting.store);
    const dispatch = useDispatch<RootDispatch>();

    const deleteTemplate = async (templateId: number, options: Options = {}) => {
        const { onSuccess, onError } = options;

        isTemplateDeleting.startDeleting();

        try {
            await dispatch.templates.deleteTemplateById(templateId);
            isTemplateDeleting.finishDeleting();

            if (onSuccess) onSuccess();
        } catch (error) {
            isTemplateDeleting.finishDeleting();
            if (onError) onError();
        }
    };

    return {
        isDeleting,
        deleteTemplate,
    };
};
